import type { JSX } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { cva } from 'class-variance-authority';
import { getCSSColorFill } from '~/utilities/getCSS';
import { COLORS, type COLOR } from '~/types/AppData/Theme/ColorInterface';

const cssClasses = cva('', {
  variants: {
    color: getCSSColorFill(),
  },
});

interface PlayIconProps {
  svgClass?: string;
  circleColor?: COLOR;
  arrowColor?: COLOR;
}

export default component$(
  ({
    svgClass,
    circleColor = COLORS.BLACK,
    arrowColor = COLORS.WHITE,
  }: PlayIconProps): JSX.Element => {
    return (
      <svg
        class={svgClass}
        width='60'
        height='60'
        viewBox='0 0 60 60'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <circle
          class={cssClasses({ color: circleColor })}
          cx='30'
          cy='30'
          r='30'
          fill-opacity='0.5'
        />
        <path
          class={cssClasses({ color: arrowColor })}
          d='M23 42.25V17.75L42.25 30L23 42.25Z'
        />
      </svg>
    );
  }
);
